import BsModal from "bootstrap/js/dist/modal";
import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react";
import { h, render } from "preact";
import { Sentry, localizePath } from "restaumatic-client/src";
import { debugAvailability } from "restaumatic-client/src/utils/debugAvailability";
import Cart from "./Cart";
export function init(state) {
    const modalElement = document.createElement("div");
    modalElement.id = "cart";
    modalElement.classList.add("modal", "fade", "cart", "cart--modal", "cart--redesigned");
    modalElement.tabIndex = -1;
    modalElement.addEventListener("shown.bs.modal", () => {
        state.isCartOpen = true;
    });
    modalElement.addEventListener("hidden.bs.modal", () => {
        state.isCartOpen = false;
    });
    document.body.appendChild(modalElement);
    render(h(CartModal, { state: state }), modalElement);
    const modal = BsModal.getOrCreateInstance(modalElement);
    state.showModal = () => modal.show();
    state.hideModal = () => modal.hide();
    return state;
}
export class CartState {
    constructor(cart) {
        this.hideModal = () => { };
        this.showModal = () => { };
        this.isCartOpen = false;
        this.cart = cart;
        makeAutoObservable(this);
    }
    goToCheckout(isSubmitDisabled) {
        if (isSubmitDisabled) {
            const debug = debugAvailability(this.cart.availability);
            Sentry.logError("Go to checkout validation error", {
                extra: {
                    unavailabilityReasons: debug.reasons,
                    availabilityErrors: debug.errors,
                    cartContext: this.cart.checkoutLoggingData,
                },
            });
            return;
        }
        this.hideModal(); // NOTICE: In the Active Menu we are always on the same page, so we need to hide the modal
        location.href = localizePath(`/zamowienie/koszyk/${this.cart.restaurantId}`);
    }
}
const CartModal = observer(({ state }) => {
    const imageUrn = window.Skubacz.configuration.theme_settings.cart_modal_image;
    return (h("div", { class: `modal-dialog ${!!imageUrn ? "modal-dialog--with-image" : ""}` },
        h("div", { class: "modal-content" },
            h(Cart, { state: state, imageUrn: imageUrn }))));
});
